import { useEffect, useRef, useState } from "react";
import { IMinerTypeSelectorProps } from "./MinerTypeSelector.props";
import { useIntl } from "react-intl";
import { useMinerProfiles } from "@utils/hooks/useMinerProfiles";
import { IMinerProfile } from "@store/minerProfiles/reducer";
import { ALGOS_E } from "@constants/Algos";

export const useMinerTypeSelectorControl = (props: IMinerTypeSelectorProps) => {

  const { formatMessage } = useIntl();
  const CLEARED_VALUE: IMinerProfile = {
    id: 0,
    name: formatMessage({ id: "selector.all" }),
    consumption: 0,
    performance: 0,
    hash: ALGOS_E.SHA256,
    meta: {},
  };

  const minerProfiles = useMinerProfiles();

  const onGetMinerProfile = (id: string | number) => {
    if (id === CLEARED_VALUE.id) {
      return props.onClearClick?.();
    }
    const profile = minerProfiles.find((p) => Number(p.id) === Number(id));
    if (!profile) return;
    props.getValue?.(profile);
  };

  return {
    CLEARED_VALUE: {
      id: CLEARED_VALUE.id,
      text: CLEARED_VALUE.name,
    },
    minerProfiles,
    onGetMinerProfile,
  };
};
